import { useState } from 'react';
import { Link, Redirect } from "react-router-dom";
import '../../App.scss';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { FaAngleLeft } from "react-icons/fa";


// Msal imports
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";

function EmailSignature() {


  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [copyButton, setCopyButton] = useState(true);

  const handleNameChange = (role, e) => {
    switch (role) {
      case 'name':
        setName(e.target.value);
        break;
      case 'role':
        setRole(e.target.value);
        break;
      case 'number':
        setPhoneNumber(e.target.value);
        break;
      default:
    }
  }

  function CopyToClipboard() {
    //document.querySelector(".show-copied").style.display = "flex";
    setCopyButton(false);

    var range = document.createRange();

    range.selectNodeContents(document.getElementById("signature-card"));

    setTimeout(function () {
      setCopyButton(true);
    }, 1000);

    window.getSelection().removeAllRanges(); // clear current selection
    window.getSelection().addRange(range); // to select text
    document.execCommand("copy");
    window.getSelection().removeAllRanges(); // to deselect
  }

  const copyButtonOnOff = () => {
    if (copyButton === true) {
      return (
        <div className="copy btn-copy" onClick={() => CopyToClipboard()}>Copy to Clipboard</div>
      )
    } else {
      return (
        <div className="copy copied">Signature Copied!</div>
      )
    }
  }

  return (
    <>
      <AuthenticatedTemplate>

        <div className="App">

          <div className="header">
            <div className="header-container">
              <h1>River Tech</h1>
              <h2>Email Signature Generator</h2>
            </div>
          </div>

          <div className="app-inner">
            <Link to="/" className="back-home">
              <FaAngleLeft className='fas' /> Back
            </Link>
            {/* FORM EDITOR */}
            <div className="inner-header">
              <div className="instructions">
                <b>Instructions:</b><br />
                Fill out your details,<br />
                Click the "Copy to Clipboard" button,<br />
                Go to the signature section of your email client and paste in your new signature!<br />
                Need help setting up your Email Signature in Outlook? ... <a className="aLink" href="https://support.microsoft.com/en-us/office/create-and-add-an-email-signature-in-outlook-com-776d9006-abdf-444e-b5b7-a61821dff034" target="_blank" rel="noreferrer">Click here</a>
              </div>
              <div className="form-fields-container">
                <input type="text" placeholder="Full Name" value={name} onChange={(e) => handleNameChange('name', e)} />
                <input type="text" placeholder="Company Role" value={role} onChange={(e) => handleNameChange('role', e)} />
                <input type="text" placeholder="Contact Number" value={phoneNumber} onChange={(e) => handleNameChange('number', e)} />
              </div>
            </div>

            {/* FOOTER SIGNATURE */}
            <div className="signature-card">
              <table cellPadding="0" cellSpacing="0" id="signature-card" style={{ verticalAlign: "-webkit-baseline-middle", fontSize: "medium", fontFamily: "Arial", background: 'white', borderRadius: '4px', padding: '16px 16px 0px 16px', border: '1px solid rgba(197,197,197, .27)' }}>
                <tbody>
                  <tr>
                    <td style={{ paddingBottom: "8px" }}>
                      <table cellPadding="0" cellSpacing="0" style={{ verticalAlign: '-webkit-baseline-middle', fontSize: 'medium', fontFamily: 'Arial' }}>
                        <tbody>
                          <tr>
                            <td width="150" style={{ verticalAlign: 'middle', paddingBottom: '8px' }}>
                              <span style={{ marginRight: '12px', display: 'block' }}>
                                <img src="data:image/png;base64,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" alt="River Tech Logo" role="presentation" width="130" height="60" style={{ maxWidth: '130px', maxHeight: '60px' }} />
                              </span>
                            </td>
                            <td style={{ verticalAlign: 'middle', paddingBottom: '8px' }}>
                              <h3 style={{ textAlign: 'left', margin: '0px', fontSize: '16px', color: 'rgb(0, 0, 0)' }}>{name}</h3>
                              <p style={{ textAlign: 'left', margin: '0px', color: 'rgb(0, 0, 0)', fontSize: '12px' }}>{role}</p>
                              <p style={{ textAlign: 'left', margin: '0px', fontWeight: '500', color: 'rgb(0, 0, 0)', fontSize: '14px', paddingTop: '4px' }}>River Tech</p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="2" style={{ borderTop: '1px solid #ddd', paddingTop: '12px' }}>
                              <table cellPadding="0" cellSpacing="0" style={{ verticalAlign: '-webkit-baseline-middle', fontSize: 'medium', fontFamily: 'Arial', paddingLeft: '8px', paddingRight: '8px' }}>
                                <tbody>
                                  {phoneNumber ?
                                    <tr height="18" style={{ verticalAlign: 'top' }}>
                                      <td width="20" style={{ textAlign: 'right', verticalAlign: 'top', fontSize: '12px', color: '#777', paddingRight: '4px' }}>tel:</td>
                                      <td style={{ textAlign: 'left', verticalAlign: 'top', fontSize: '12px', color: '#777', padding: '0px' }}>
                                        <span color="#777" style={{ textAlign: 'left', verticalAlign: 'top', fontSize: '12px', color: '#777' }}>
                                          {phoneNumber}
                                        </span>
                                      </td>
                                    </tr>
                                    :
                                    null
                                  }
                                  <tr height="18" style={{ verticalAlign: 'top' }}>
                                    <td width="20" style={{ textAlign: 'right', verticalAlign: 'top', fontSize: '12px', color: '#777', paddingRight: '4px' }}>web:</td>
                                    <td style={{ textAlign: 'left', verticalAlign: 'top', fontSize: '12px', color: '#777', textDecoration: 'none', padding: '0px' }}>
                                      <a href="https://www.river.tech" target="_blank" rel="noreferrer" color="#777" style={{ textAlign: 'left', verticalAlign: 'top', textDecoration: 'none', color: '#777', fontSize: '12px' }}>
                                        <font color='#777' style={{ textAlign: 'left' }}>www.river.tech</font>
                                      </a>
                                    </td>
                                  </tr>
                                  <tr height="18" style={{ verticalAlign: 'top' }}>
                                    <td width="20" style={{ textAlign: 'right', verticalAlign: 'top', fontSize: '12px', color: '#777', paddingRight: '4px', paddingBottom: "16px" }}>addr:</td>
                                    <td style={{ verticalAlign: 'top', padding: '0px', paddingBottom: "16px" }}>
                                      <span color="#777" style={{ textAlign: 'left', verticalAlign: 'top', fontSize: '12px', color: '#777' }}>
                                        Aragon House Business Centre,<br />Dragonara Road, St Julian's, Malta
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan="2" style={{ textAlign: 'left', verticalAlign: 'center', paddingTop: '8px', borderTop: "1px solid #ddd" }}>
                                      <a href="https://river.tech/e-mail-disclaimer-notice/" target="_blank" rel="noreferrer" color="#777" style={{ textAlign: 'left', verticalAlign: 'center', textDecoration: 'none', color: '#777', fontSize: '10px' }}>
                                        E-mail Disclaimer Notice
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div >

            {/* ACTIONS */}
            <div className="actions">
              {copyButtonOnOff()}
            </div>


          </div>

        </div>

      </AuthenticatedTemplate >
      <UnauthenticatedTemplate>
        <Redirect to="/" />
      </UnauthenticatedTemplate>
    </>
  );
}

export default EmailSignature;
